<template>
  <div class="">
    <ul role="list" class="-mb-8" v-if="!loading">
      <li v-for="(activityItem, activityItemIdx) in activities" :key="activityItem.id">
        <div class="relative pb-8 pt-2">
          <span v-if="activityItemIdx !== activities.length - 1" class="absolute top-5 left-4 -ml-px h-full w-0.5 bg-brand-sand" aria-hidden="true" />
          <CustomerSessionCard :session="activityItem" v-if="activityItem.timelineType === 'session'" class="relative flex items-start space-x-3" />
          <CustomerInvoiceCard :invoice="activityItem" v-if="activityItem.timelineType === 'invoice'" class="relative flex items-start space-x-3" />
          <CustomerEventCard :event="activityItem" v-else-if="activityItem.timelineType === 'event'" class="relative flex items-start space-x-3" />
          <CustomerEmailCard :email="activityItem" v-else-if="activityItem.timelineType === 'email'" class="relative flex items-start space-x-3" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { LOAD_STATE } from '@/store/shared';
import CustomerEventCard from '@/components/CancelAnalytics/Customer/CustomerEventCard.vue';
import CustomerSessionCard from '@/components/CancelAnalytics/Customer/CustomerSessionCard.vue';
import CustomerInvoiceCard from '@/components/CancelAnalytics/Customer/CustomerInvoiceCard.vue';
import CustomerEmailCard from '@/components/CancelAnalytics/Customer/CustomerEmailCard.vue';
import { mapState } from 'vuex';

export default {
  name: 'CustomerActivities',
  components: {
    CustomerSessionCard,
    CustomerEventCard,
    CustomerEmailCard,
    CustomerInvoiceCard,
  },
  props: {
    showExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['customerProfile', 'customerProfileLoadState']),
    loading() {
      return this.customerProfileLoadState === LOAD_STATE.LOADING;
    },
    customer() {
      return this.customerProfile?.customer;
    },
    activities() {
      return this.customerProfile?.activities;
    },
  },
};
</script>
